module.exports = __webpack_public_path__ + "img/_dsc8174.1a07e0aa.jpg";